import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import IconMaterial from './IconMaterial.vue';
import Tooltip from './Tooltip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IconnButton',
  props: {
  id: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  leftIcon: {
    type: String,
    default: '',
  },
  rightIcon: {
    type: String,
    default: '',
  },
  fullWidth: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'md',
  },
  sizeIcon: {
    type: Number,
    default: null,
  },
  type: {
    type: String,
    default: 'primary',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  colorIcon: {
    type: String,
    default: '',
  },
  iconVariant: {
    type: String,
    default: '',
  },
  slim: {
    type: Boolean,
    default: false,
  },
  fontWeight: {
    type: String as () => 'thin' | 'light' | 'regular' | 'medium' | 'bold' | 'black',
    default: 'regular',
  },
  isConnectMeetBtn: {
    type: Boolean,
    default: false,
  },
  square: {
    type: Boolean,
    default: false,
  },
},
  emits: ['onClick'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const onClick = () => {
  emit('onClick');
};

const iconNeedsBottomMargin = ref(['icon_right', 'icon_iconnections', 'icon_save']);

const iconSize = computed(() => {
  if (props.sizeIcon) {
    return props.sizeIcon;
  }
  switch (props.size) {
    case 'sm':
      return 16;
    case 'md':
      return 16;
    case 'lg':
      return 20;
    default:
      return 16;
  }
});

const customColorIcon = computed(() => {
  if (props.colorIcon) {
    return props.colorIcon;
  }
  return '';
});

const bottomMargin = computed(() => {
  if (iconNeedsBottomMargin.value.includes(props.rightIcon)) {
    return '12px';
  }
  if (iconNeedsBottomMargin.value.includes(props.leftIcon)) {
    return '2.5px';
  }
  return '0';
});

const buttonClass = computed(() => {
  const fullWidthClass = props.fullWidth ? 'full_width' : '';
  const slimClass = props.slim ? 'slim' : '';
  const fontWeightClass = `font-weight-${props.fontWeight}`;
  const sizeClass = `button_${props.size}`;
  const typeClass = `button_${props.type}`;
  const square = props.square ? 'square' : '';
  return [fullWidthClass, slimClass, fontWeightClass, sizeClass, typeClass, square];
});

const __returned__ = { props, emit, onClick, iconNeedsBottomMargin, iconSize, customColorIcon, bottomMargin, buttonClass, IconMaterial, Tooltip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})